export default {
  DEVELOPERERRORLOG_LIST (state, value) {
    state.list = (value && Array.isArray(value)) ? value : []
  }
}
